// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zmQqf","right":"styles_right__21cd0"};